import angular from 'angular';
import nameWithIcon from './nameWithIcon';

export default angular
  .module('components.nameWithIcon', [])
  .component('nameWithIcon', nameWithIcon).name;
